/* tslint:disable */
/* eslint-disable */
/**
 * Downtime-logs per il BackOffice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Ogni disservizio è relativo ad almeno una funzionalità
 * @export
 * @interface BoStatusUpdateEvent
 */
export interface BoStatusUpdateEvent {
    /**
     * 
     * @type {PnFunctionalityStatus}
     * @memberof BoStatusUpdateEvent
     */
    'status': PnFunctionalityStatus;
    /**
     * richiesta precisione al millisecondo.
     * @type {string}
     * @memberof BoStatusUpdateEvent
     */
    'timestamp': string;
    /**
     * 
     * @type {PnFunctionality}
     * @memberof BoStatusUpdateEvent
     */
    'functionality': PnFunctionality;
    /**
     * Descrizione dell\'evento in formato HTML. <br/>
     * @type {string}
     * @memberof BoStatusUpdateEvent
     */
    'htmlDescription'?: string;
}


/**
 * - __NOTIFICATION_CREATE__: la possibilità di creare nuove notifiche. - __NOTIFICATION_VISUALIZATION__: la possibilità di visualizzare le notifiche e scaricare gli atti.  - __NOTIFICATION_WORKFLOW__: l\'avanzamento del processo di notifica. 
 * @export
 * @enum {string}
 */

export const PnFunctionality = {
    NOTIFICATION_CREATE: 'NOTIFICATION_CREATE',
    NOTIFICATION_VISUALIZATION: 'NOTIFICATION_VISUALIZATION',
    NOTIFICATION_WORKFLOW: 'NOTIFICATION_WORKFLOW'
} as const;

export type PnFunctionality = typeof PnFunctionality[keyof typeof PnFunctionality];


/**
 * 
 * @export
 * @enum {string}
 */

export const PnFunctionalityStatus = {
    Ko: 'KO',
    Ok: 'OK'
} as const;

export type PnFunctionalityStatus = typeof PnFunctionalityStatus[keyof typeof PnFunctionalityStatus];


/**
 * 
 * @export
 * @interface Problem
 */
export interface Problem {
    /**
     * URI reference of type definition
     * @type {string}
     * @memberof Problem
     */
    'type'?: string;
    /**
     * The HTTP status code generated by the origin server for this occurrence of the problem.
     * @type {number}
     * @memberof Problem
     */
    'status': number;
    /**
     * A short, summary of the problem type. Written in english and readable
     * @type {string}
     * @memberof Problem
     */
    'title': string;
    /**
     * A human readable explanation of the problem.
     * @type {string}
     * @memberof Problem
     */
    'detail'?: string;
    /**
     * 
     * @type {string}
     * @memberof Problem
     */
    'traceId'?: string;
    /**
     * 
     * @type {Array<ProblemError>}
     * @memberof Problem
     */
    'errors': Array<ProblemError>;
}
/**
 * 
 * @export
 * @interface ProblemError
 */
export interface ProblemError {
    /**
     * Internal code of the error
     * @type {string}
     * @memberof ProblemError
     */
    'code': string;
    /**
     * A human readable explanation specific to this occurrence of the problem.
     * @type {string}
     * @memberof ProblemError
     */
    'detail': string;
}

/**
 * DowntimeBoApi - axios parameter creator
 * @export
 */
export const DowntimeBoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Permette di aggiungere un evento di inizio o fine di un disservizio, può essere richiamato sia dagli allarmi automatici che da GUI. Tali casi vanno discriminati con l\'attributo di richiesta _sourceType_.
         * @summary Modifica stato di servizio
         * @param {string} xPagopaPnUid User Identifier
         * @param {BoStatusUpdateEvent} boStatusUpdateEvent Parametri necessari per generare il documento
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStatusChangeEventBo: async (xPagopaPnUid: string, boStatusUpdateEvent: BoStatusUpdateEvent, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPagopaPnUid' is not null or undefined
            assertParamExists('addStatusChangeEventBo', 'xPagopaPnUid', xPagopaPnUid)
            // verify required parameter 'boStatusUpdateEvent' is not null or undefined
            assertParamExists('addStatusChangeEventBo', 'boStatusUpdateEvent', boStatusUpdateEvent)
            const localVarPath = `/downtime-bo/v1/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xPagopaPnUid != null) {
                localVarHeaderParameter['x-pagopa-pn-uid'] = String(xPagopaPnUid);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(boStatusUpdateEvent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ritorna il pdf per la preview dell\'atto opponibile a terzi per il malfunzionamento
         * @summary Preview AO3 malfunzionamento
         * @param {string} xPagopaPnUid User Identifier
         * @param {BoStatusUpdateEvent} boStatusUpdateEvent Parametri necessari per generare il documento
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMalfunctionPreview: async (xPagopaPnUid: string, boStatusUpdateEvent: BoStatusUpdateEvent, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPagopaPnUid' is not null or undefined
            assertParamExists('getMalfunctionPreview', 'xPagopaPnUid', xPagopaPnUid)
            // verify required parameter 'boStatusUpdateEvent' is not null or undefined
            assertParamExists('getMalfunctionPreview', 'boStatusUpdateEvent', boStatusUpdateEvent)
            const localVarPath = `/downtime-bo/v1/legal-facts/malfunction/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xPagopaPnUid != null) {
                localVarHeaderParameter['x-pagopa-pn-uid'] = String(xPagopaPnUid);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(boStatusUpdateEvent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DowntimeBoApi - functional programming interface
 * @export
 */
export const DowntimeBoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DowntimeBoApiAxiosParamCreator(configuration)
    return {
        /**
         * Permette di aggiungere un evento di inizio o fine di un disservizio, può essere richiamato sia dagli allarmi automatici che da GUI. Tali casi vanno discriminati con l\'attributo di richiesta _sourceType_.
         * @summary Modifica stato di servizio
         * @param {string} xPagopaPnUid User Identifier
         * @param {BoStatusUpdateEvent} boStatusUpdateEvent Parametri necessari per generare il documento
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStatusChangeEventBo(xPagopaPnUid: string, boStatusUpdateEvent: BoStatusUpdateEvent, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStatusChangeEventBo(xPagopaPnUid, boStatusUpdateEvent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DowntimeBoApi.addStatusChangeEventBo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ritorna il pdf per la preview dell\'atto opponibile a terzi per il malfunzionamento
         * @summary Preview AO3 malfunzionamento
         * @param {string} xPagopaPnUid User Identifier
         * @param {BoStatusUpdateEvent} boStatusUpdateEvent Parametri necessari per generare il documento
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMalfunctionPreview(xPagopaPnUid: string, boStatusUpdateEvent: BoStatusUpdateEvent, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMalfunctionPreview(xPagopaPnUid, boStatusUpdateEvent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DowntimeBoApi.getMalfunctionPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DowntimeBoApi - factory interface
 * @export
 */
export const DowntimeBoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DowntimeBoApiFp(configuration)
    return {
        /**
         * Permette di aggiungere un evento di inizio o fine di un disservizio, può essere richiamato sia dagli allarmi automatici che da GUI. Tali casi vanno discriminati con l\'attributo di richiesta _sourceType_.
         * @summary Modifica stato di servizio
         * @param {string} xPagopaPnUid User Identifier
         * @param {BoStatusUpdateEvent} boStatusUpdateEvent Parametri necessari per generare il documento
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStatusChangeEventBo(xPagopaPnUid: string, boStatusUpdateEvent: BoStatusUpdateEvent, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addStatusChangeEventBo(xPagopaPnUid, boStatusUpdateEvent, options).then((request) => request(axios, basePath));
        },
        /**
         * Ritorna il pdf per la preview dell\'atto opponibile a terzi per il malfunzionamento
         * @summary Preview AO3 malfunzionamento
         * @param {string} xPagopaPnUid User Identifier
         * @param {BoStatusUpdateEvent} boStatusUpdateEvent Parametri necessari per generare il documento
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMalfunctionPreview(xPagopaPnUid: string, boStatusUpdateEvent: BoStatusUpdateEvent, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getMalfunctionPreview(xPagopaPnUid, boStatusUpdateEvent, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DowntimeBoApi - object-oriented interface
 * @export
 * @class DowntimeBoApi
 * @extends {BaseAPI}
 */
export class DowntimeBoApi extends BaseAPI {
    /**
     * Permette di aggiungere un evento di inizio o fine di un disservizio, può essere richiamato sia dagli allarmi automatici che da GUI. Tali casi vanno discriminati con l\'attributo di richiesta _sourceType_.
     * @summary Modifica stato di servizio
     * @param {string} xPagopaPnUid User Identifier
     * @param {BoStatusUpdateEvent} boStatusUpdateEvent Parametri necessari per generare il documento
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DowntimeBoApi
     */
    public addStatusChangeEventBo(xPagopaPnUid: string, boStatusUpdateEvent: BoStatusUpdateEvent, options?: RawAxiosRequestConfig) {
        return DowntimeBoApiFp(this.configuration).addStatusChangeEventBo(xPagopaPnUid, boStatusUpdateEvent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ritorna il pdf per la preview dell\'atto opponibile a terzi per il malfunzionamento
     * @summary Preview AO3 malfunzionamento
     * @param {string} xPagopaPnUid User Identifier
     * @param {BoStatusUpdateEvent} boStatusUpdateEvent Parametri necessari per generare il documento
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DowntimeBoApi
     */
    public getMalfunctionPreview(xPagopaPnUid: string, boStatusUpdateEvent: BoStatusUpdateEvent, options?: RawAxiosRequestConfig) {
        return DowntimeBoApiFp(this.configuration).getMalfunctionPreview(xPagopaPnUid, boStatusUpdateEvent, options).then((request) => request(this.axios, this.basePath));
    }
}



